export default __webpack_public_path__ + "static/media/BCA25.cae0cb60.jpg";